import React, { FC, ReactNode } from 'react'
import { useApiInstance } from 'src/hooks/api'
import { PresignedDownloadLink } from './presignedDownloadLink'

interface AttachmentLinkProps {
  attachmentId: number;
  children: ReactNode;
}

export const AttachmentLink: FC<AttachmentLinkProps> = ({ attachmentId, children}) => {
  const api = useApiInstance()

  return (
    <PresignedDownloadLink getUrl={() => api.v1AdminAttachmentsAttachmentIdDownloadLinkGet(attachmentId)}>
      {children}
    </PresignedDownloadLink>
  )
}
